import colorLib from '@kurkle/color';
import parsePhoneNumber from 'libphonenumber-js';
import { GenericLabelValue } from './models/DTO/GenericLabelValue.dto';
import { CCProcessors } from './models/enums/CCProcessors.enum';
import { ChartLegendPosition } from './models/enums/ChartLegendPosition.enum';
import { CheckSources } from './models/enums/check-sources';
import { CreditCardType } from './models/enums/CreditCardType.enum';
import { OrderTypeIncludeNameFormat } from './models/enums/order-type-include-name-format.enum';
import { OrderTypeIncludeNamePrefix } from './models/enums/order-type-include-name-prefix.enum copy';

export class References {
	static einMask = [/\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
	static ssnMask = [/\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
	static phoneMask = ['(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
	static phoneValidateRegex = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;

	static focusPayDeviceTypes: GenericLabelValue[] = [
		{
			label: 'e280',
			value: 'e280',
		},
		{
			label: 'e285p',
			value: 'e285p',
		},
		{
			label: 'Castle w/ Printer',
			value: 'S1F2',
		},
		{
			label: 'Castle w/o printer',
			value: 'S1E',
		},
		{
			label: 'P400plus',
			value: 'P400plus',
		},
	];

	static daysOfWeek = [
		{
			label: 'Sunday',
			value: 0,
		},
		{
			label: 'Monday',
			value: 1,
		},
		{
			label: 'Tuesday',
			value: 2,
		},
		{
			label: 'Wednesday',
			value: 3,
		},
		{
			label: 'Thursday',
			value: 4,
		},
		{
			label: 'Friday',
			value: 5,
		},
		{
			label: 'Saturday',
			value: 6,
		},
	];

	static months = [
		{ label: '01 - Jan', value: '01' },
		{ label: '02 - Feb', value: '02' },
		{ label: '03 - Mar', value: '03' },
		{ label: '04 - Apr', value: '04' },
		{ label: '05 - May', value: '05' },
		{ label: '06 - Jun', value: '06' },
		{ label: '07 - Jul', value: '07' },
		{ label: '08 - Aug', value: '08' },
		{ label: '09 - Sep', value: '09' },
		{ label: '10 - Oct', value: '10' },
		{ label: '11 - Nov', value: '11' },
		{ label: '12 - Dec', value: '12' },
	];

	static states = [
		{
			label: 'Alabama',
			value: 'AL',
		},
		{
			label: 'Alaska',
			value: 'AK',
		},
		{
			label: 'Arizona',
			value: 'AZ',
		},
		{
			label: 'Arkansas',
			value: 'AR',
		},
		{
			label: 'California',
			value: 'CA',
		},
		{
			label: 'Colorado',
			value: 'CO',
		},
		{
			label: 'Connecticut',
			value: 'CT',
		},
		{
			label: 'Delaware',
			value: 'DE',
		},
		{
			label: 'District Of Columbia',
			value: 'DC',
		},
		{
			label: 'Florida',
			value: 'FL',
		},
		{
			label: 'Georgia',
			value: 'GA',
		},
		{
			label: 'Guam',
			value: 'GU',
		},
		{
			label: 'Hawaii',
			value: 'HI',
		},
		{
			label: 'Idaho',
			value: 'ID',
		},
		{
			label: 'Illinois',
			value: 'IL',
		},
		{
			label: 'Indiana',
			value: 'IN',
		},
		{
			label: 'Iowa',
			value: 'IA',
		},
		{
			label: 'Kansas',
			value: 'KS',
		},
		{
			label: 'Kentucky',
			value: 'KY',
		},
		{
			label: 'Louisiana',
			value: 'LA',
		},
		{
			label: 'Maine',
			value: 'ME',
		},
		{
			label: 'Maryland',
			value: 'MD',
		},
		{
			label: 'Massachusetts',
			value: 'MA',
		},
		{
			label: 'Michigan',
			value: 'MI',
		},
		{
			label: 'Minnesota',
			value: 'MN',
		},
		{
			label: 'Mississippi',
			value: 'MS',
		},
		{
			label: 'Missouri',
			value: 'MO',
		},
		{
			label: 'Montana',
			value: 'MT',
		},
		{
			label: 'Nebraska',
			value: 'NE',
		},
		{
			label: 'Nevada',
			value: 'NV',
		},
		{
			label: 'New Hampshire',
			value: 'NH',
		},
		{
			label: 'New Jersey',
			value: 'NJ',
		},
		{
			label: 'New Mexico',
			value: 'NM',
		},
		{
			label: 'New York',
			value: 'NY',
		},
		{
			label: 'North Carolina',
			value: 'NC',
		},
		{
			label: 'North Dakota',
			value: 'ND',
		},
		{
			label: 'Ohio',
			value: 'OH',
		},
		{
			label: 'Oklahoma',
			value: 'OK',
		},
		{
			label: 'Oregon',
			value: 'OR',
		},
		{
			label: 'Pennsylvania',
			value: 'PA',
		},
		{
			label: 'Puerto Rico',
			value: 'PR',
		},
		{
			label: 'Rhode Island',
			value: 'RI',
		},
		{
			label: 'South Carolina',
			value: 'SC',
		},
		{
			label: 'South Dakota',
			value: 'SD',
		},
		{
			label: 'Tennessee',
			value: 'TN',
		},
		{
			label: 'Texas',
			value: 'TX',
		},
		{
			label: 'Utah',
			value: 'UT',
		},
		{
			label: 'Vermont',
			value: 'VT',
		},
		{
			label: 'Virgin Islands',
			value: 'VI',
		},
		{
			label: 'Virginia',
			value: 'VA',
		},
		{
			label: 'Washington',
			value: 'WA',
		},
		{
			label: 'West Virginia',
			value: 'WV',
		},
		{
			label: 'Wisconsin',
			value: 'WI',
		},
		{
			label: 'Wyoming',
			value: 'WY',
		},
	];

	static years = [
		{ label: 2022, value: '2022' },
		{ label: 2023, value: '2023' },
		{ label: 2024, value: '2024' },
		{ label: 2025, value: '2025' },
		{ label: 2026, value: '2026' },
		{ label: 2027, value: '2027' },
		{ label: 2028, value: '2028' },
		{ label: 2029, value: '2029' },
		{ label: 2030, value: '2030' },
		{ label: 2031, value: '2031' },
		{ label: 2032, value: '2032' },
		{ label: 2033, value: '2033' },
		{ label: 2034, value: '2034' },
		{ label: 2035, value: '2035' },
		{ label: 2036, value: '2036' },
		{ label: 2037, value: '2037' },
		{ label: 2038, value: '2038' },
		{ label: 2039, value: '2039' },
		{ label: 2040, value: '2040' },
	];

	static includeNameFormat = [
		{
			label: 'First Name',
			value: OrderTypeIncludeNameFormat.FIRSTNAME,
		},
		{
			label: 'Last Name',
			value: OrderTypeIncludeNameFormat.LASTNAME,
		},
		{
			label: 'Last, First',
			value: OrderTypeIncludeNameFormat.LASTANDFIRST,
		},
		{
			label: 'First and Last',
			value: OrderTypeIncludeNameFormat.FIRSTANDLAST,
		},
		{
			label: 'First and Last Initial',
			value: OrderTypeIncludeNameFormat.FIRSTANDLASTINITIAL,
		},
	];

	static includeNamePrefix = [
		{
			label: 'None',
			value: OrderTypeIncludeNamePrefix.NONE,
		},
		{
			label: 'For:',
			value: OrderTypeIncludeNamePrefix.FOR,
		},
		{
			label: 'Guest:',
			value: OrderTypeIncludeNamePrefix.GUEST,
		},
		{
			label: 'Name:',
			value: OrderTypeIncludeNamePrefix.NAME,
		},
		{
			label: 'Order:',
			value: OrderTypeIncludeNamePrefix.ORDER,
		},
	];

	static fontAwesomePrefixes = [
		{
			label: 'Regular',
			value: 'far',
		},
		{
			label: 'Solid',
			value: 'fas',
		},
		{
			label: 'Light',
			value: 'fal',
		},
		{
			label: 'Dual tone',
			value: 'fad',
		},
		{
			label: 'Brands',
			value: 'fab',
		},
	];

	static commandCenterTones = [
		{ label: 'None', value: 0 },
		{
			label: 'Old Cash Register',
			value: 1,
		},
		{
			label: '1920s',
			value: 2,
		},
		{
			label: 'Alert',
			value: 3,
		},
	];

	static toTitleCase(str) {
		if (!isNaN(str)) str += '';
		const exclusionWords = ['BBQ', 'HQ', 'BTT', 'OMFG'];
		if (str) {
			if (exclusionWords.some((i) => str.includes(i))) return str;
			return str.replace(/\w\S*/g, function (txt) {
				return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
			});
		}
		return str;
	}

	static phoneNumberToDisplayFormat(phoneNumber: string): string {
		if (!phoneNumber.includes('+1')) {
			phoneNumber = `+1${phoneNumber}`;
		}

		return parsePhoneNumber(phoneNumber).format('NATIONAL');
	}

	static randomStrokeFillGenerator() {
		const fill = {
			r: getRandomInt(30, 230),
			g: getRandomInt(30, 230),
			b: getRandomInt(30, 230),
		};

		const stroke = {
			r: fill.r + 10,
			g: fill.g + 10,
			b: fill.b + 10,
		};

		return {
			stroke: `#${compToHex(stroke.r)}${compToHex(stroke.g)}${compToHex(stroke.b)}`,
			fill: `#${compToHex(fill.r)}${compToHex(fill.g)}${compToHex(fill.b)}`,
		};

		function compToHex(val: number) {
			let hex = val.toString(16);
			return hex.length == 1 ? '0' + hex : hex;
		}
		function getRandomInt(min, max) {
			return Math.floor(Math.random() * (max - min + 1)) + min;
		}
	}

	static pastelColorGenerator(qty: number) {
		const returnColors: string[] = [];
		for (let i = 0; i < qty; i++) {
			returnColors.push('hsl(' + 360 * Math.random() + ',' + (25 + 70 * Math.random()) + '%,' + (65 + 10 * Math.random()) + '%)');
		}
		return returnColors;
	}

	static pastelColorList = [
		'#77dd77',
		'#836953',
		'#89cff0',
		'#99c5c4',
		'#9adedb',
		'#aa9499',
		'#aaf0d1',
		'#b2fba5',
		'#b39eb5',
		'#bdb0d0',
		'#bee7a5',
		'#befd73',
		'#c1c6fc',
		'#c6a4a4',
		'#cb99c9',
		'#fdfd96',
		'#ff6961',
		'#ff694f',
		'#ff9899',
		'#ffb7ce',
		'#ca9bf7',
	];

	static chartColorsGoogle = [
		'#3366CC',
		'#DC3912',
		'#FF9900',
		'#109618',
		'#990099',
		'#3B3EAC',
		'#0099C6',
		'#DD4477',
		'#66AA00',
		'#B82E2E',
		'#316395',
		'#994499',
		'#22AA99',
		'#AAAA11',
		'#6633CC',
		'#E67300',
		'#8B0707',
		'#329262',
		'#5574A6',
		'#3B3EAC',
		'#3366CC',
		'#DC3912',
		'#FF9900',
		'#109618',
		'#990099',
		'#3B3EAC',
		'#0099C6',
		'#DD4477',
		'#66AA00',
		'#B82E2E',
		'#316395',
		'#994499',
		'#22AA99',
		'#AAAA11',
		'#6633CC',
		'#E67300',
		'#8B0707',
		'#329262',
		'#5574A6',
		'#3B3EAC',
		'#3366CC',
		'#DC3912',
		'#FF9900',
		'#109618',
		'#990099',
		'#3B3EAC',
		'#0099C6',
		'#DD4477',
		'#66AA00',
		'#B82E2E',
		'#316395',
		'#994499',
		'#22AA99',
		'#AAAA11',
		'#6633CC',
		'#E67300',
		'#8B0707',
		'#329262',
		'#5574A6',
		'#3B3EAC',
	];

	static colorPallete = {
		primary: '#168fed',
		secondary: '#56707D',
		warning: '#E0A701',
		danger: '#cf1d2e',
		success: '#5E8F32',
		moneyGreen: '#22f24b',
		laborRed: '#f22c22',
	};

	static transparentize(value, opacity) {
		var alpha = opacity === undefined ? 0.5 : 1 - opacity;
		return colorLib(value).alpha(alpha).rgbString();
	}

	static delay(ms: number) {
		return new Promise((resolve) => setTimeout(resolve, ms));
	}

	static phoneToformatE164(value: string): string {
		value = value.toString().replace(/ /g, '').replace(/-/g, '').replace(/[(]/, '').replace(/[)]/, '');

		if (!value.includes('+1')) {
			value = '+1' + value;
		}

		return value;
	}

	static checkSource(source): string {
		switch (source) {
			case 'focus-onlineorder':
				return `FocusOnline`;
			case `focus-on`:
				return `FocusON`;
			case `focus-hub`:
				return `Hub`;
			case `doordash`:
				return `DoorDash`;
			case `doordash`:
				return `UberEats`;
			case undefined:
				return `In-Store`;
			default:
				return source;
		}
	}

	static creditCardTypeToDisplayObject(
		type?: number,
		strValue?: string,
		ccProcessorSource?: number
	): {
		name: string;
		number: number;
		faIcon: string;
	} {
		if (!type && strValue) {
			if (ccProcessorSource === CCProcessors.FOCUSPAYDATACAP) {
				switch (strValue) {
					case 'AMEX':
						type = CreditCardType.AX;
						break;
					case 'DCVR':
						type = CreditCardType.NS;
						break;
					case 'M/C':
						type = CreditCardType.MC;
						break;
					case 'VISA':
						type = CreditCardType.VS;
						break;
					default:
						break;
				}
			} else {
				switch (strValue) {
					case 'VS':
						type = CreditCardType.VS;
						break;
					case 'AX':
						type = CreditCardType.AX;
						break;
					case 'MC':
						type = CreditCardType.MC;
						break;
					case 'NS':
						type = CreditCardType.NS;
						break;
					case 'JC':
						type = CreditCardType.JC;
						break;
				}
			}
		}
		switch (type) {
			case CreditCardType.AX:
				return {
					number: type,
					name: 'American Express',
					faIcon: `cc-amex`,
				};
			case CreditCardType.JC:
				return {
					number: type,
					name: 'JCB',
					faIcon: `cc-jcb`,
				};
			case CreditCardType.MC:
				return {
					number: type,
					name: 'MasterCard',
					faIcon: 'cc-mastercard',
				};
			case CreditCardType.NS:
				return {
					number: type,
					name: 'Discover',
					faIcon: 'cc-discover',
				};
			case CreditCardType.VS:
				return {
					number: type,
					name: 'Visa',
					faIcon: 'cc-visa',
				};
			case CreditCardType.OTHER:
				return {
					number: type,
					name: 'Other',
					faIcon: 'credit-card-front',
				};
		}
	}

	static checkSourceObjectFromCheckEnum(source: number): {
		number: number;
		faIcon: string;
		displayName: string;
	} {
		switch (source) {
			case CheckSources.HUB:
				return {
					number: source,
					faIcon: 'laptop-code',
					displayName: 'Focus Hub',
				};
			case CheckSources.Kiosk:
				return {
					number: source,
					faIcon: 'tv-alt',
					displayName: 'Kiosk order',
				};
			case CheckSources.MobilePay:
				return {
					number: source,
					faIcon: 'mobile',
					displayName: 'Paid with MobilePay',
				};
			case CheckSources.On:
				return {
					number: source,
					faIcon: 'mobile-android-alt',
					displayName: 'FocusOn order',
				};
			case CheckSources.OnlineOrder:
				return {
					number: source,
					faIcon: 'shopping-cart',
					displayName: 'Online order',
				};
			case CheckSources.POS:
				return {
					number: source,
					faIcon: 'store',
					displayName: 'In-store purchase',
				};
			case CheckSources.Subscription:
				return {
					number: source,
					faIcon: 'hand-holding-box',
					displayName: 'Subscription',
				};
			default:
				return {
					number: source,
					faIcon: 'store',
					displayName: 'In-store purchase',
				};
		}
	}

	static colorComponentToHex(c) {
		var hex = c.toString(16);
		return hex.length == 1 ? '0' + hex : hex;
	}

	static colorRgbToHex(r, g, b) {
		return '#' + this.colorComponentToHex(r) + this.colorComponentToHex(g) + this.colorComponentToHex(b);
	}

	static colorHexToRgb(hex) {
		var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
		return result
			? {
					r: parseInt(result[1], 16),
					g: parseInt(result[2], 16),
					b: parseInt(result[3], 16),
			  }
			: null;
	}

	static duration(inputTime): number {
		return Math.ceil((new Date().getTime() - inputTime) / 1000);
	}

	static chartConfig(legendPosition: string, yTicks: boolean, xTicks: boolean) {
		const config = {
			responsive: true,
			plugins: {
				legend: {
					display: legendPosition === ChartLegendPosition.NONE ? false : true,
					position: legendPosition === ChartLegendPosition.NONE ? undefined : ChartLegendPosition.NONE,
					labels: {
						color: '#495057',
					},
				},
			},
		};

		return config;
	}

	static lineChartConfig(chartTitle: string, data?: any) {
		return {
			stacked: false,
			responsive: true,
			plugins: {
				legend: {
					position: 'right',
					labels: {
						color: '#495057',
					},
				},
			},
			scales: {
				x: {
					ticks: {
						color: '#495057',
					},
					grid: {
						color: '#ebedef',
					},
				},
				y: {
					type: 'linear',
					display: true,
					position: 'left',
					ticks: {
						color: '#495057',
					},
					grid: {
						color: '#ebedef',
					},
				},
				y1: {
					type: 'linear',
					display: true,
					position: 'right',
					ticks: {
						color: '#495057',
					},
					grid: {
						drawOnChartArea: false,
						color: '#ebedef',
					},
				},
			},
		};
	}
}
